export const fmtMoney = (v) =>
  `$ ${Number(v || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtNum = (v) => Number(v || 0).toLocaleString('es-AR');

export const fmtCuit = (c) => {
  const d = String(c || '').replace(/\D/g, '');
  return d.length === 11 ? `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}` : (c || '—');
};

export const fmtFechaHoraAR = (iso) => (iso
  ? new Date(iso).toLocaleString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires', hour12: false, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' })
  : '—');

export const fmtFecha = (iso) => (iso ? iso.slice(0, 10).split('-').reverse().join('/') : '—');

export const fmtFechaHora = (iso) => {
  if (!iso) return '—';
  const [d, t] = iso.split('T');
  return `${fmtFecha(d)} ${(t || '').slice(0, 5)}`;
};

export const isoHoy = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

const iso = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);

export const ATAJOS = [
  { key: 'mes', label: 'Este mes', rango: () => { const h = new Date(); return [iso(new Date(h.getFullYear(), h.getMonth(), 1)), isoHoy()]; } },
  { key: 'mes-ant', label: 'Mes anterior', rango: () => { const h = new Date(); return [iso(new Date(h.getFullYear(), h.getMonth() - 1, 1)), iso(new Date(h.getFullYear(), h.getMonth(), 0))]; } },
  { key: '3m', label: 'Últimos 3 meses', rango: () => { const h = new Date(); return [iso(new Date(h.getFullYear(), h.getMonth() - 3, h.getDate())), isoHoy()]; } },
  { key: 'anio', label: 'Año en curso', rango: () => [`${new Date().getFullYear()}-01-01`, isoHoy()] },
  { key: '2025', label: 'Año 2025', rango: () => ['2025-01-01', '2025-12-31'] },
];

export const ESTADOS_PEDIDO = {
  GENERANDO: { label: 'Generando', cls: 'bg-amber-100 text-amber-800' },
  LISTO: { label: 'Listo', cls: 'bg-emerald-100 text-emerald-800' },
  ERROR: { label: 'Error', cls: 'bg-red-100 text-red-700' },
};

export const descargarArchivo = async (api, pedido, formato) => {
  const r = await api.get(`/export-movimientos/pedidos/${pedido.id}/archivo/${formato}`, { responseType: 'blob' });
  const nombre = (pedido.archivos || []).find((a) => a.formato === formato)?.nombre || `${pedido.numero}.${formato.toLowerCase()}`;
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  a.click();
  URL.revokeObjectURL(url);
};
